<template>
  <!-- 信息填写页（2） -->
  <div :class="goNextBtn ? 'ownerInfo' : ''">
    <div v-show="showRelatePage">
      <div class="li-content">
        <div class="border-style">
          <div class="model-head">
            <h3>车主信息</h3>
            <a v-if="isShowCarMessage" @click="choiceTipVisible(0)">身份证识别</a>
            <img v-if="isShowCarMessage" :src="imgAreaUrl" alt="" @click="choiceTipVisible(0)">
          </div>
        </div>
        <div class="border-style">
          <mt-cell title="车主性质">
            <div class="nature">
              <span :class="carOwnerInfo.vehicleOwnerNature === '1' ? 'blue': ''" @click="getNatureStatus('1','A')">个人</span>
              <span :class="carOwnerInfo.vehicleOwnerNature === '3' ? 'blue': ''" @click="getNatureStatus('3','A')">企业</span>
              <span :class="carOwnerInfo.vehicleOwnerNature === '2' ? 'blue': ''" @click="getNatureStatus('2','A')">机关</span>
            </div>
          </mt-cell>
        </div>
        <div class="border-style">
          <div class="model-head">
            <h3 style="font-weight:normal">
              {{ textCarName }}
            </h3>
            <input v-model="carOwnerInfo.carOwner" type="text" :placeholder="textCarDesc" class="border-input">
          </div>
        </div>
        <div class="border-style" @click="ShowPapersTypePup(0)">
          <mt-cell title="证件类型" is-link>
            <span style="color:rgba(102,102,102,1)">{{ ownerIdentifyType }}</span>
          </mt-cell>
        </div>
        <div class="border-style">
          <mt-field v-model="carOwnerInfo.ownerIdentifyNumber" label="证件号码" placeholder="请输入证件号码" @blur.native.capture="checkIdentityNumber(ownerIdentifyType, carOwnerInfo.ownerIdentifyNumber)" />
        </div>
        <div class="border-style">
          <mt-field v-model="carOwnerInfo.ownerAddress" :label="textCarAddress" :placeholder="textCarAddressDesc" @blur.native.capture="checkAddress(carOwnerInfo.ownerAddress)" />
        </div>
        <div class="border-style custom">
          <p class="name">
            {{ textCarPhone }}
          </p>
          <input v-model="carOwnerInfo.mobile" class="input" type="text" :placeholder="textCarPhoneDesc" maxlength="11" @blur="checkPhoneNum(carOwnerInfo.mobile)">
        </div>
        <div class="border-style">
          <mt-field v-model="carOwnerInfo.email" label="电子邮箱" placeholder="请输入电子邮箱" @blur.native.capture="checkEmail(carOwnerInfo.email)" />
        </div>
      </div>
      <div class="li-content">
        <div class="border-style" @click="onSelectRecognizee">
          <mt-cell class="title-weight" title="被保人" is-link>
            <span style="color:rgba(102,102,102,1)">{{ recognizeeInData }}</span>
          </mt-cell>
        </div>
        <div class="border-style">
          <div v-if="RidentifyType === '身份证' && isShowOcrInsured && recognizeeIn.insuredNature === '3'" class="model-head" @click="choiceTipVisible(1)">
            <h3>被保人信息</h3>
            <a>身份证识别</a>
            <img :src="imgAreaUrl" alt="">
          </div>
        </div>
        <div>
          <div class="border-style">
            <mt-cell title="客户性质">
              <div class="nature">
                <span :class="recognizeeIn.insuredNature === '3' ? 'blue': ''" @click="getNatureStatus('3','B')">个人</span>
                <span :class="recognizeeIn.insuredNature === '4' ? 'blue': ''" @click="getNatureStatus('4','B')">企业</span>
              </div>
            </mt-cell>
          </div>
          <div class="border-style">
            <div class="model-head">
              <h3 style="font-weight:normal">
                被保人姓名
              </h3>
              <input v-model="recognizeeIn.insuredName" type="text" placeholder="请输入被保人姓名" class="border-input">
            </div>
          </div>
          <div v-if="recognizeeIn.insuredNature === '4'" class="border-style" @click="ShowPapersTypePup(3)">
            <mt-cell title="单位性质" is-link>
              <span style="color:rgba(102,102,102,1)">{{ RunitNature }}</span>
            </mt-cell>
          </div>
          <div class="border-style" @click="ShowPapersTypePup(1)">
            <mt-cell title="证件类型" is-link>
              <span style="color:rgba(102,102,102,1)">{{ RidentifyType }}</span>
            </mt-cell>
          </div>
          <div class="border-style">
            <mt-field v-model="recognizeeIn.identifyNumber" label="证件号码" placeholder="请输入证件号码" @blur.native.capture="checkIdentityNumber(RidentifyType, recognizeeIn.identifyNumber)" />
          </div>
          <div v-if="recognizeeIn.insuredNature === '3' && RidentifyType==='身份证'" class="oriModelName">
            <span>证件有效起期</span>
            <div style="flex:1;" @click="onTimeChoice('5')">
              <p v-if="recognizeeIn.iDStartDate !== ''">
                {{ recognizeeIn.iDStartDate }}
              </p>
              <p v-if="recognizeeIn.iDStartDate === ''">
                请选择
              </p>
              <van-icon name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div v-if="recognizeeIn.insuredNature === '3' && RidentifyType==='身份证'" id="oriModelName" class="oriModelName">
            <span>证件有效止期</span>
            <van-checkbox v-model="radio" checked-color="#F29600" class="border-style-checkbox" @change="onChange($event, 1)">
              长期有效
            </van-checkbox>
            <div style="flex:1;" @click="onTimeChoice('3')">
              <p v-if="recognizeeIn.validDate !== ''">
                {{ recognizeeIn.validDate }}
              </p>
              <van-icon v-if="!radio" name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div v-if="recognizeeIn.insuredNature === '3'" class="oriModelName" @click="onTimeChoice('1')">
            <span>出生日期</span>
            <div>
              <p v-if="recognizeeIn.birthday !== ''">
                {{ recognizeeIn.birthday }}
              </p>
              <p v-if="recognizeeIn.birthday === ''">
                请选择出生日期
              </p>
              <van-icon name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div v-if="recognizeeIn.insuredNature === '3'" class="oriModelName">
            <span>职业类别</span>
            <div @click="showOccupation('recognizeeIn')">
              <p>{{ recognizeeIn.occupationName }}</p>
              <van-icon name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div class="border-style">
            <mt-field v-model="recognizeeIn.address" label="被保人地址" placeholder="请输入被保人地址" @blur.native.capture="checkAddress(recognizeeIn.address)" />
          </div>
          <div class="border-style">
            <mt-field v-model="recognizeeIn.email" label="电子邮箱" placeholder="请输入电子邮箱" @blur.native.capture="checkEmail(recognizeeIn.email)" />
          </div>
          <div v-if="recognizeeIn.insuredNature === '3'" class="border-style" @click="unpack(0, RidentifyType)">
            <mt-cell title="性别" is-link>
              <span style="color:rgba(102,102,102,1)">{{ sex }}</span>
            </mt-cell>
          </div>
          <div class="border-style custom">
            <p class="name">
              {{ textRecognizeeInMoblie }}
            </p>
            <input v-model="recognizeeIn.mobile" class="input" type="text" :placeholder="textRecognizeeInMoblieDesc" maxlength="11" @blur="checkPhoneNum(recognizeeIn.mobile)">
          </div>
          <div v-if="recognizeeIn.insuredNature === '3'" class="border-style">
            <mt-field v-model="recognizeeIn.longAddress" label="长久居住地" placeholder="请输入被保人长久居住地" @blur.native.capture="checkAddress(recognizeeIn.longAddress)" />
          </div>
          <div v-if="recognizeeIn.insuredNature === '4'" class="border-style">
            <mt-field v-model="recognizeeIn.linkerName" label="联系人名称" placeholder="请输入联系人名称" />
          </div>
        </div>
      </div>
      <div class="li-content">
        <div class="border-style" @click="onSelectApplicant">
          <mt-cell class="title-weight" title="投保人" is-link>
            <span style="color:rgba(102,102,102,1)">{{ applicantInData }}</span>
          </mt-cell>
        </div>
        <div v-if="applicantInData !== '同被保人'" class="border-style">
          <div v-if="AidentifyType === '身份证' && isShowOcrInsuredApplicant && applicantIn.insuredNature === '3'" class="model-head" @click="choiceTipVisible(2)">
            <h3>投保人信息</h3>
            <a>身份证识别</a>
            <img :src="imgAreaUrl" alt="">
          </div>
        </div>
        <div v-if="applicantInData !== '同被保人'">
          <div class="border-style">
            <mt-cell title="客户性质">
              <div class="nature">
                <span :class="applicantIn.insuredNature === '3' ? 'blue': ''" @click="getNatureStatus('3','C')">个人</span>
                <span :class="applicantIn.insuredNature === '4' ? 'blue': ''" @click="getNatureStatus('4','C')">企业</span>
              </div>
            </mt-cell>
          </div>
          <div class="border-style">
            <div class="model-head">
              <h3 style="font-weight:normal">
                投保人姓名
              </h3>
              <input v-model="applicantIn.insuredName" type="text" placeholder="请输入投保人姓名" class="border-input">
            </div>
          </div>
          <div v-if="applicantIn.insuredNature === '4'" class="border-style" @click="ShowPapersTypePup(4)">
            <mt-cell title="单位性质" is-link>
              <span style="color:rgba(102,102,102,1)">{{ AunitNature }}</span>
            </mt-cell>
          </div>
          <div class="border-style" @click="ShowPapersTypePup(2)">
            <mt-cell title="证件类型" is-link>
              <span style="color:rgba(102,102,102,1)">{{ AidentifyType }}</span>
            </mt-cell>
          </div>
          <div class="border-style">
            <mt-field v-model="applicantIn.identifyNumber" label="证件号码" placeholder="请输入证件号码" @blur.native.capture="checkIdentityNumber(AidentifyType, applicantIn.identifyNumber)" />
          </div>
          <div v-if="applicantIn.insuredNature === '3' && AidentifyType==='身份证'" id="oriModelName" class="oriModelName">
            <span>证件有效起期</span>
            <div style="flex:1;" @click="onTimeChoice('6')">
              <p v-if="applicantIn.iDStartDate !== ''">
                {{ applicantIn.iDStartDate }}
              </p>
              <p v-if="applicantIn.iDStartDate === ''">
                请选择
              </p>
              <van-icon name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div v-if="applicantIn.insuredNature === '3' && AidentifyType==='身份证'" id="oriModelName" class="oriModelName">
            <span>证件有效止期</span>
            <van-checkbox v-model="radios" checked-color="#F29600" class="border-style-checkbox" @change="onChange($event, 2)">
              长期有效
            </van-checkbox>
            <div style="flex:1;" @click="onTimeChoice('4')">
              <p v-if="applicantIn.validDate !== ''">
                {{ applicantIn.validDate }}
              </p>
              <van-icon v-if="!radios" name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div v-if="applicantIn.insuredNature === '3'" class="oriModelName" @click="onTimeChoice('2')">
            <span>出生日期</span>
            <div>
              <p v-if="applicantIn.birthday !== ''">
                {{ applicantIn.birthday }}
              </p>
              <p v-if="applicantIn.birthday === ''">
                请选择出生日期
              </p>
              <van-icon name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div v-if="applicantIn.insuredNature === '3'" class="oriModelName">
            <span>职业类别</span>
            <div @click="showOccupation('applicantIn')">
              <p>{{ applicantIn.occupationName }}</p>
              <van-icon name="arrow" size="12" color="#ccc" />
            </div>
          </div>
          <div class="border-style">
            <mt-field v-model="applicantIn.address" label="投保人地址" placeholder="请输入投保人地址" @blur.native.capture="checkAddress(applicantIn.address)" />
          </div>
          <div class="border-style">
            <mt-field v-model="applicantIn.email" label="电子邮箱" placeholder="请输入电子邮箱" @blur.native.capture="checkEmail(applicantIn.email)" />
          </div>
          <div v-if="applicantIn.insuredNature === '3'" class="border-style" @click="unpack(1, AidentifyType)">
            <mt-cell title="性别" is-link>
              <span style="color:rgba(102,102,102,1)">{{ sexs }}</span>
            </mt-cell>
          </div>
          <div class="border-style custom">
            <p class="name">
              {{ textApplicantInMobile }}
            </p>
            <input v-model="applicantIn.mobile" class="input" type="text" :placeholder="textApplicantInMobileMessage" maxlength="11" @blur="checkPhoneNum(recognizeeIn.mobile)">
          </div>
          <div v-if="applicantIn.insuredNature === '3'" class="border-style">
            <mt-field v-model="applicantIn.longAddress" label="长久居住地" placeholder="请输入被保人长久居住地" @blur.native.capture="checkAddress(applicantIn.longAddress)" />
          </div>
          <div v-if="applicantIn.insuredNature === '4'" class="border-style">
            <mt-field v-model="applicantIn.linkerName" label="联系人名称" placeholder="请输入被保人联系人名称" @blur.native.capture="fixScroll" />
          </div>
        </div>
        <div v-if="network" class="client" @click="choice">
          <van-icon :name="choose ? 'checked' : 'circle'" size="16" :color="choose ? '#F29600' : ''" class="icons" /><span>将客户信息存入“客户管理中心”</span>
        </div>
      </div>
      <div v-show="goNextBtn" class="next-step">
        <button class="save-btn" @click="save">
          暂存
        </button>
        <button @click="onInsure(1)">
          投保
        </button>
      </div>
      <!--时间选择器-->
      <van-popup v-model="dateShow" position="bottom" close-on-click-overlay>
        <van-datetime-picker
          type="date"
          :value="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirm($event)"
          @cancel="dateShow=false"
        />
      </van-popup>
      <!--生效日期时间选择器-->
      <van-popup v-model="valDateShow" position="bottom" close-on-click-overlay>
        <van-datetime-picker
          type="date"
          :value="currentDate"
          :min-date="minDate"
          :max-date="valmaxDate"
          @confirm="onConfirm($event)"
          @cancel="valDateShow=false"
        />
      </van-popup>
      <!--弹框选择-->
      <van-popup v-model="popupShow" position="bottom" close-on-click-overlay>
        <van-picker
          :columns="columns"
          show-toolbar
          @confirm="onConfirm"
          @cancel="popupShow = false"
        />
      </van-popup>
      <!--客户选择-->
      <van-popup v-model="isContact" position="bottom" close-on-click-overlay style="height:600px;">
        <Customer @isContact="choiceContact($event)" @cuntomer="getCutomer($event)" />
      </van-popup>
      <van-popup v-model="IsShowOccupation" round position="bottom" lock-scroll :close-on-click-overlay="false">
        <div class="showClose">
          <div class="blank">
            <div class="title">
              <span @click="levelGoBack()"><van-icon name="down" class="icon" /></span>
              <span v-show="showLevelName1" class="occupation">请选择</span>
              <div v-show="showLevelName2" class="occupation">
                <span>{{ levelName1 ? levelName1 : '请选择' }}</span>
              </div>
              <div v-show="showLevelName3" class="occupation">
                <span>{{ levelName2 ? levelName2 : '请选择' }}</span>
              </div>
            </div>
          </div>
          <div class="content">
            <ul>
              <li v-for="(item, index1) in occupationList" v-show="showLevelName1" :key="item.id" @click="getLevelName1(item, index1)">
                {{ item.codecname }}
              </li>
              <li v-for="(item, index2) in level2List" v-show="showLevelName2" :key="item.id" @click="getLevelName2(item, index2)">
                {{ item.codecname }}
              </li>
              <li v-for="(item, index3) in level3List" v-show="showLevelName3" :key="item.id" @click="getLevelName3(item, index3)">
                {{ item.codecname }}
              </li>
            </ul>
          </div>
        </div>
      </van-popup>
    </div>
    <idCardNumber
      v-show="!showRelatePage"
      :car-owner-info="carOwnerInfo"
      @goBack="goBack"
      @newSuccessOcr="newSuccessOcr"
    />
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import idCardNumber from '../idCardIdentify/index.vue'
import api from '@/api/api.js'
import { Toast } from 'vant'
import checkFormat from '@/utils/checkFormat.js'
import Loading from '@/components/Loadings/Loading'
import Customer from '@/components/Customer/index'
import { mapGetters } from 'vuex'
import { relateMixin } from './Mixin/mixin'
import { identifyTypesList, identifyTypeOne, identifyTypeTwo } from '@/utils/const.js'
export default {
  components: {
    'Loading': Loading,
    'Customer': Customer,
    'idCardNumber': idCardNumber
  },
  mixins: [relateMixin],
  data() {
    return {
      showRelatePage: true,
      cuntomerFlag: '', // 判断客户选择值赋给车主还是投保人，被保人
      isContact: false, // 客户选择弹窗
      choose: true,
      sex: '',
      sexs: '',
      imgobjs: [],
      switchs: false,
      dateOfBirth: '', // 车主生日
      validDate: '', // 车主证件有效期
      radio: false, // 被保人长期有效无
      radios: false, // 投保人长期有效
      valmaxDate: new Date(9999, 12, 31), // 证件有效期最大可选
      currentDate: new Date(),
      minDate: new Date(1949, 1, 1),
      maxDate: new Date(),
      valDateShow: false, // 有效期控制按钮
      dateShow: false, // 时间选择器控制按钮
      RunitNature: '', // 被保人单位性质
      AunitNature: '', // 投保人单位性质
      isShowCarMessage: true, // 是否展示车主信息
      textApplicantInMobileMessage: '请输入手机号码',
      textApplicantInMobile: '手机号码',
      textRecognizeeInMoblie: '手机号码',
      textRecognizeeInMoblieDesc: '请输入手机号码',
      textCarPhoneDesc: '请输入手机号码',
      textCarPhone: '手机号码',
      textCarAddressDesc: '请输入家庭地址',
      textCarAddress: '家庭地址',
      textCarDesc: '请输入车主姓名',
      textCarName: '车主姓名',
      numStatus: '', // 判断车主，被保人，投保人
      isShowOcrInsured: false, // 展示被保人的OCR
      isShowOcrInsuredApplicant: false, // 展示投保人的OCR
      imgUrlCamera: api.imgAllUrl + '/sales140709.png',
      imgAreaUrl: api.imgAllUrl + '/sales290709.png',
      imgRefresh: api.imgAllUrlZSB + '/yeleiRefresh.png',
      imgcontact: api.imgAllUrl + '/contact.png',
      tipVisible: false, // 上传身份证弹框
      tipVisibles: false, // 紫属保APP上传身份证弹框
      showInfo1: false, // 被保人
      showInfo2: false, // 投保人
      applicantInData: '同车主', // 当前选择的投保人
      recognizeeInData: '同车主', // 当前选择的被保人
      AidentifyType: '身份证', // 投保人证件类型
      RidentifyType: '身份证', // 被保人证件类型
      ownerIdentifyType: '身份证',
      popupShow: false, // 单项选择器
      columns: [],
      status: '',
      carOwnerInfo: {
        vehicleOwnerNature: '1', // 车主性质
        carOwner: '', // 车主姓名
        ownerIdentifyType: '01', // 证件类型
        ownerIdentifyNumber: '', // 证件号码
        mobile: '', //
        email: '', //
        ownerAddress: ''
      },
      // 投保人信息
      applicantIn: {
        address: '',
        age: '',
        birthday: '',
        email: '',
        identifyNumber: '',
        identifyType: '01',
        insuredFlag: '2',
        insuredIdentity: '01',
        insuredName: '',
        insuredNature: '3',
        insuredRelationship: '0', // 投保人关系 0同车主 1同被保人 2其他
        insuredType: '1',
        longAddress: '',
        mobile: '',
        iDStartDate: '', // 证件有效期起期
        validDate: '',
        occupationCode: '030199', // 投保人职业代码
        occupationName: '其他办事人员' // 投保人职业名称
      },
      // 被保人信息
      recognizeeIn: {
        address: '',
        age: '',
        birthday: '',
        email: '',
        identifyNumber: '',
        identifyType: '01',
        insuredFlag: '1',
        insuredIdentity: '01',
        insuredName: '',
        insuredNature: '3',
        insuredRelationship: '3', // 被保人关系 3同车主 4其他
        insuredType: '1',
        longAddress: '',
        mobile: '',
        iDStartDate: '', // 证件有效期起期
        validDate: '',
        occupationCode: '030199', // 被保人职业代码
        occupationName: '其他办事人员' // 被保人职业名称
      },
      vehicleInfo: {}, // 车辆信息
      IdentifyType: '',
      insuredList: [],
      condition: false,
      goNextBtn: true,
      originHeight: '',
      conditions: 0,
      gender: [], // 数据字典查询的性别信息
      reverses: false, // 反面ocr是否识别
      handleFiles: false, // 正面ocr是否识别
      network: false, // 是否是APP进入
      occupationList: [], // 职业类别列表
      IsShowOccupation: false, // 控制职业类别选择器
      levelName1: '',
      levelName2: '',
      levelName3: '',
      showLevelName1: true,
      showLevelName2: false,
      showLevelName3: false,
      level2List: [],
      level3List: [],
      personFlag: '',
      channelCode: ''
    }
  },
  computed: {
    ...mapGetters({
      productXInfoDTOList: 'productXInfoDTOList'
    })
  },
  watch: {
    conditions(value) {
      if (value > 3) {
        this.condition = false
      }
    },
    carOwnerInfo: {
      handler(newval, oldVal) {
        if (this.condition) {
          this.conditions += 1
        } else {
          this.assignment()
          this.$store.commit('setAlter', '2')
        }
      },
      deep: true
    },
    recognizeeIn: {
      handler(newval, oldVal) {
        this.recognizeeInassignment()
        if (this.RidentifyType === '身份证') {
          if (this.condition) {
            this.conditions += 1
          } else {
            if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 1) {
              this.gender.forEach(value => {
                if (value.codecname === '男') {
                  newval.sex = value.codeCode
                  this.sex = value.codecname
                }
              })
            } else if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 0) {
              this.gender.forEach(value => {
                if (value.codecname === '女') {
                  newval.sex = value.codeCode
                  this.sex = value.codecname
                }
              })
            }
            this.recognizeeIn.birthday = checkFormat.identifyNumberToBirthday(this.recognizeeIn.identifyNumber)
          }
        }
        if (!this.condition) {
          this.$store.commit('setAlter', '2')
        }
      },
      deep: true
    },
    applicantIn: {
      handler(newval, oldVal) {
        if (this.AidentifyType === '身份证') {
          if (this.condition) {
            this.conditions += 1
          } else {
            if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 1) {
              this.gender.forEach(value => {
                if (value.codecname === '男') {
                  newval.sex = value.codeCode
                  this.sexs = value.codecname
                }
              })
            } else if (parseInt(newval.identifyNumber.substr(16, 1)) % 2 === 0) {
              this.gender.forEach(value => {
                if (value.codecname === '女') {
                  newval.sex = value.codeCode
                  this.sexs = value.codecname
                }
              })
            }
            this.applicantIn.birthday = checkFormat.identifyNumberToBirthday(this.applicantIn.identifyNumber)
          }
        }
        if (!this.condition) {
          this.$store.commit('setAlter', '2')
        }
      },
      deep: true
    },
    validDate: function(newval, oldVal) {
      if (this.recognizeeInData === '同车主') {
        this.recognizeeIn.validDate = newval
      }
      if (this.applicantInData === '同车主') {
        this.applicantIn.validDate = newval
      }
      this.filterValiDate()
    },
    deep: true
  },
  mounted() {
    if (localStorage.getItem('setChannelCode') === 'ZKICATM') {
      this.network = !this.$store.state.mark
    }
    this.channelCode = localStorage.getItem('setChannelCode')
    this.show()
    this.$http.post(api.getByCodeType, { codeType: 'SexCode' }).then(res => {
      res.data.forEach(value => {
        this.gender.push({
          codeCode: value.codeCode,
          codecname: value.codecname
        })
      })
      if (this.recognizeeIn.identifyNumber && this.recognizeeIn.identifyNumber !== '') {
        if (parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 === 1) {
          this.gender.forEach(value => {
            if (value.codecname === '男') {
              this.recognizeeIn.sex = value.codeCode
              this.sex = value.codecname
            }
          })
        } else if (parseInt(this.recognizeeIn.identifyNumber.substr(16, 1)) % 2 === 0) {
          this.gender.forEach(value => {
            if (value.codecname === '女') {
              this.recognizeeIn.sex = value.codeCode
              this.sex = value.codecname
            }
          })
        }
      }
      if (this.applicantIn.identifyNumber && this.applicantIn.identifyNumber !== '') {
        if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 1) {
          this.gender.forEach(value => {
            if (value.codecname === '男') {
              this.applicantIn.sex = value.codeCode
              this.sexs = value.codecname
            }
          })
        } else if (parseInt(this.applicantIn.identifyNumber.substr(16, 1)) % 2 === 0) {
          this.gender.forEach(value => {
            if (value.codecname === '女') {
              this.applicantIn.sex = value.codeCode
              this.sexs = value.codecname
            }
          })
        }
      }
      Toast.clear()
      this.switchs = false
    })
      .catch(error => {
        console.log(error)
        this.switchs = false
      })
  },
  activated() {
    this.originHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
    if (isAndroid) {
      window.addEventListener('resize', this.resizeFn)
    }
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.$store.commit('setShow', true)
    this.$store.commit('setStep', '2')
    const appUrl = window.location.href
    if (appUrl.indexOf('terminalId=APP') !== -1) {
      console.log(1)
    } else if (appUrl.indexOf('token') !== -1) {
      console.log(2)
    } else {
      const obj = JSON.parse(localStorage.getItem('setPersonUserInfo'))
      if (this.applicantIn.insuredName === '' || this.applicantIn.insuredName === null) {
        this.applicantIn.insuredName = obj.name || ''
      }
      if (this.applicantIn.identifyNumber === '' || this.applicantIn.identifyNumber === null) {
        this.applicantIn.identifyNumber = obj.identifyNum || ''
      }
      if (this.applicantIn.mobile === '' || this.applicantIn.mobile === null) {
        this.applicantIn.mobile = obj.phoneNumber || ''
      }
    }
    this.getCodeType()
  },
  deactivated() {
    this.$store.commit('setStep', '')
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeFn)
    this.goNextBtn = true
  },
  methods: {
    goBack() {
      this.$store.commit('setShow', true)
      this.showRelatePage = true
      this.goNextBtn = true
    },
    _filter(List, name, code) {
      let result = []
      for (let i = 0; i < List.length; i++) {
        if (code === List[i].codeCode) {
          result = List[i][name]
        }
      }
      return result
    },
    // 获取职业类别
    getCodeType() {
      const data = {
        codeType: 'ProfessionType'
      }
      this.$http.post(api.getCodeType, data).then(res => {
        if (res.data.rtnCode === '0000' && res.data.result) {
          //  组装数据
          const levelData1 = res.data.result.filter(item1 => item1.codeLevel === '1')
          const levelData2 = res.data.result.filter(item1 => item1.codeLevel === '2')
          const levelData3 = res.data.result.filter(item1 => item1.codeLevel === '3')
          levelData1.forEach(el1 => {
            el1.levelTwoList = []
            levelData2.forEach(el2 => {
              if (el2.upperCode === el1.codeCode) {
                el1.levelTwoList.push(el2)
              }
              el2.levelThreeList = []
              levelData3.forEach(el3 => {
                if (el3.upperCode === el2.codeCode) {
                  el2.levelThreeList.push(el3)
                }
              })
            })
          })
          this.occupationList = levelData1
          console.log(this.occupationList, '职业类别组装数据')
        }
      })
    },
    // 展示职业类别弹框
    showOccupation(flag) {
      this.IsShowOccupation = true
      this.personFlag = flag
    },
    // 弹框返回事件
    levelGoBack() {
      if (this.showLevelName1) {
        this.IsShowOccupation = false
        this.showLevelName1 = true
        this.showLevelName2 = false
        this.showLevelName3 = false
        this.levelName1 = ''
        this.levelName2 = ''
        this.levelName3 = ''
      }
      if (this.showLevelName2) {
        this.showLevelName1 = true
        this.showLevelName2 = false
        this.showLevelName3 = false
        this.levelName1 = ''
        this.levelName2 = ''
      }
      if (this.showLevelName3) {
        this.showLevelName1 = false
        this.showLevelName2 = true
        this.showLevelName3 = false
        this.levelName2 = ''
      }
    },
    // 职业类别一级选择
    getLevelName1(params, index) {
      this.levelName1 = params.codecname
      this.showLevelName1 = false
      this.showLevelName2 = true
      this.showLevelName3 = false
      this.level2List = this._filter(this.occupationList, 'levelTwoList', params.codeCode)
    },
    // 职业类别二级选择
    getLevelName2(params, index) {
      this.levelName2 = params.codecname
      this.showLevelName1 = false
      this.showLevelName2 = false
      this.showLevelName3 = true
      this.level3List = this._filter(this.level2List, 'levelThreeList', params.codeCode)
    },
    // 职业类别三级选择
    getLevelName3(params, index) {
      this[this.personFlag].occupationCode = params.codeCode
      this[this.personFlag].occupationName = params.codecname
      this.showLevelName1 = true
      this.showLevelName2 = false
      this.showLevelName3 = false
      this.IsShowOccupation = false
      this.levelName1 = ''
      this.levelName2 = ''
      this.levelName3 = ''
    },
    // 车主选择
    choiceContact(status) {
      this.isContact = !this.isContact
      this.cuntomerFlag = status
    },
    resizeFn() {
      const resizeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      this.goNextBtn = this.originHeight - 0 <= resizeHeight - 0
    },
    // 过滤证件有效期
    filterValiDate() {
      if (this.recognizeeIn.validDate === '长期' || this.recognizeeIn.validDate === '9999-12-31') {
        this.radio = true
        this.recognizeeIn.validDate = '9999-12-31'
      } else {
        this.radio = false
      }
      if (this.applicantIn.validDate === '长期' || this.applicantIn.validDate === '9999-12-31') {
        this.radios = true
        this.applicantIn.validDate = '9999-12-31'
      } else {
        this.radios = false
      }
    },
    identifyTypes() {
      this.switchs = true
      this.$http.post(api.getByMoreCodeType, identifyTypesList)
        .then(res => {
          res.data.result.forEach(value => {
            if (this.applicantIn.businessSort === value.codeCode && value.codeType === 'UnitProperties') {
              this.AunitNature = value.codecname
            }
            if (this.recognizeeIn.businessSort === value.codeCode && value.codeType === 'UnitProperties') {
              this.RunitNature = value.codecname
            }
            if (this.applicantIn.identifyType === value.codeCode && value.codeType === 'CarBusinessIndentifyType') {
              this.AidentifyType = value.codecname
            }
            if (this.recognizeeIn.identifyType === value.codeCode && value.codeType === 'CarBusinessIndentifyType') {
              this.RidentifyType = value.codecname
            }
            if (this.applicantIn.identifyType === value.codeCode && value.codeType === 'CarPersonalIndentifyType') {
              this.AidentifyType = value.codecname
            }
            if (this.recognizeeIn.identifyType === value.codeCode && value.codeType === 'CarPersonalIndentifyType') {
              this.RidentifyType = value.codecname
            }
          })
          this.switchs = false
        })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    },
    /**
     * 长期有效选择
     */
    onChange(event, num) {
      if (num === 1) {
        this.radio = event
        this.recognizeeIn.validDate = this.radio === true ? '9999-12-31' : this.recognizeeIn.validDate
      }
      if (num === 2) {
        this.radios = event
        this.applicantIn.validDate = this.radios === true ? '9999-12-31' : this.applicantIn.validDate
      }
    },
    unpack(val, content) {
      if (val === 0) {
        this.status = 'sex0'
      } else {
        this.status = 'sex1'
      }
      this.popupShow = true
      this.columns = []
      console.log(this.gender)
      this.gender.forEach(value => {
        if (value.codeCode !== '9') {
          this.columns.push({
            text: value.codecname,
            code: value.codeCode
          })
        }
      })
    },
    /**
     * 证件类型选择弹窗
     * @param val
     * 0车主，1被保人，2投保人,3被保人单位性质,4投保人单位性质
     */
    ShowPapersTypePup(val) {
      if (val === 0) {
        this.status = 'IdentifyType0'
        this.popupShow = true
        this.columns = []
        this.columns = this.carOwnerInfo.vehicleOwnerNature === '1' ? identifyTypeOne : identifyTypeTwo
        for (const i in this.columns) {
          if (this.carOwnerInfo.ownerIdentifyType === this.columns[i].code) {
            this.columns.defaultIndex = Number(i)
          }
        }
      } else if (val === 1) {
        this.status = 'IdentifyType1'
        if (this.recognizeeIn.insuredNature === '3') {
          this.dictionary('CarPersonalIndentifyType')
        } else {
          this.dictionary('CarBusinessIndentifyType')
        }
      } else if (val === 2) {
        this.status = 'IdentifyType2'
        if (this.applicantIn.insuredNature === '3') {
          this.dictionary('CarPersonalIndentifyType')
        } else {
          this.dictionary('CarBusinessIndentifyType')
        }
      } else if (val === 3) {
        this.status = 'IdentifyType3'
        this.dictionary('UnitProperties')
      } else if (val === 4) {
        this.status = 'IdentifyType4'
        this.dictionary('UnitProperties')
      }
    },
    // 时间选择器弹出
    onTimeChoice(num) {
      this.status = num
      if (num === '1' || num === '2') {
        this.dateShow = true
      }
      if (num === '3' || num === '4' || num === '5' || num === '6') {
        if ((num === '3' || num === '4') && this.radios) {
          return false
        } else {
          this.valDateShow = true
        }
      }
    },
    /**
     * ocr选择弹框
     * @param no
     * 0车主，1被保人，2投保人
     */
    choiceTipVisible(no) {
      this.numStatus = no
      this.$store.commit('setShow', false)
      this.goNextBtn = false
      this.showRelatePage = false
    },
    // 证件类型
    dictionary(codeType) {
      const param = {
        codeType: codeType
      }
      this.columns = []
      this.switchs = true
      this.$http.post(api.getByCodeType, param).then(res => {
        Toast.clear()
        if (res.status === 200) {
          this.popupShow = true
          this.IdentifyType = res.data
          this.IdentifyType.forEach(item => {
            const obj = {
              text: item.codecname,
              code: item.codeCode
            }
            this.columns.push(obj)
          })
          let datas
          switch (this.status) {
            case 'IdentifyType1':
              datas = this.recognizeeIn.identifyType
              break
            case 'IdentifyType2':
              datas = this.applicantIn.identifyType
              break
            case 'IdentifyType3':
              datas = this.recognizeeIn.businessSort
              break
            case 'IdentifyType4':
              datas = this.applicantIn.businessSort
              break
          }
          for (const i in this.columns) {
            if (datas === this.columns[i].code) {
              this.columns.defaultIndex = Number(i)
            }
          }
        }
        this.switchs = false
      })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    },
    // 验证手机号
    checkPhoneNum(param, judge) {
      if (judge) {
        if (param !== '') {
          if (checkFormat.checkPhone(param) === false) {
            this.$toast('请检查该手机号：“' + param + '”的格式是否正确')
            return false
          } else {
            return true
          }
        }
      }
    },
    // 校验邮箱
    checkEmail(email, judge) {
      if (judge) {
        if (email === undefined) {
          return true
        } else if (email !== '') {
          if (checkFormat.checkEmail(email) === false) {
            this.$toast('请检查该邮箱：“' + email + '”的格式是否正确')
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    },
    // 校验地址
    checkAddress(address, judge) {
      if (judge) {
        if (address.length < 12) {
          this.$toast('请检查地址：“ ' + address + ' ”是否完善至门牌号')
          return false
        } else {
          return true
        }
      }
    },
    // 身份证校验
    checkIdentityNumber(identy, IdentityNumber, judge) {
      if (judge) {
        if (identy === '身份证') {
          if (checkFormat.isCardNo(IdentityNumber) === false) {
            this.$toast('请检查身份证号：“ ' + IdentityNumber + '” 是否正确')
            return false
          } else {
            return true
          }
        } else if (identy === '统一社会信用代码') {
          IdentityNumber = IdentityNumber.replace(/ /g, '')
          if (IdentityNumber.length > 15 && IdentityNumber.length < 19) {
            return true
          } else {
            this.$toast('请检查统一社会信用证号：“' + IdentityNumber + '”是否正确')
            return false
          }
        } else {
          return true
        }
      }
    },
    // 新版OCR识别
    newSuccessOcr(newVal, isFront, isBack) {
      this.$toast('请注意核对自动识别出的信息是否正确')
      this.condition = false
      if (isFront) {
        this.carOwnerInfo.carOwner = newVal.name
        this.carOwnerInfo.ownerIdentifyNumber = newVal.idCardNumber
        this.carOwnerInfo.ownerAddress = newVal.residentialAddress
        this.ownerIdentifyType = '身份证'
        this.dateOfBirth = newVal.dateOfBirth
        this.imgobjs.forEach((value, index) => {
          if (value.status === 0) {
            this.imgobjs.splice(index, 1)
          }
        })
        this.imgobjs.push({
          fileId: newVal.frontFileId,
          fileType: '3',
          status: 0
        })
      }
      if (isBack) {
        this.validDate = newVal.endDate
        this.filterValiDate()
        if (this.recognizeeInData === '同车主') {
          this.recognizeeIn.iDStartDate = newVal.startDate
        }
        if (this.applicantInData === '同车主') {
          this.applicantIn.iDStartDate = newVal.startDate
        }
        this.imgobjs.forEach((value, index) => {
          if (value.status === 3) {
            this.imgobjs.splice(index, 1)
          }
        })
        this.imgobjs.push({
          fileId: newVal.backFileId,
          fileType: '3',
          status: 3
        })
      }
      this.goBack()
    },
    // 选择被保人类型
    onSelectRecognizee() {
      this.popupShow = true
      this.status = 'r'
      this.columns = []
      this.columns = [
        {
          text: '同车主',
          code: '3'
        },
        {
          text: '其他',
          code: '4'
        }
      ]
    },
    // 选择投保人类型
    onSelectApplicant() {
      this.popupShow = true
      this.status = 'a'
      this.columns = []
      this.columns = [
        {
          text: '同车主',
          code: '0'
        },
        {
          text: '同被保人',
          code: '1'
        },
        {
          text: '其他',
          code: '2'
        }
      ]
    },
    // 暂存
    save() {
      this.saveMessage()
    },
    // 投保
    onInsure(type) {
      this.saveMessage(type)
      this.$store.commit('setCarOwnerInfo', this.carOwnerInfo)
      this.$store.commit('setApplicantIn', this.applicantIn)
      this.$store.commit('setRecognizeeIn', this.recognizeeIn)
    },
    choice() { // 选择是否存入客户信息
      this.choose = !this.choose
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./ownerInfo.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/relate/index.vue